import React, { useEffect, useState } from "react";
import axios from "axios";
import InvoiceForBd from "./WithdrawalInvoice"; // Reuse the same bill view component

const statusColors = {
    0: "#faad14", // Pending - orange
    1: "#52c41a", // Approved - green
    2: "#ff4d4f", // Rejected - red
};

const AgencyBillListToBd = () => {
    const [bills, setBills] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const [searchInput, setSearchInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [bd, setBd] = useState("");
    const [viewBill, setViewBill] = useState(null);

    useEffect(() => {
        const storedData = sessionStorage.getItem("bd");
        if (storedData) {
            try {
                const obj = JSON.parse(storedData);
                setBd(obj.uniqueId || "");
            } catch {
                setBd("");
            }
        }
    }, []);

    const fetchBills = async (searchAgencyId = "") => {
        if (!bd) return;
        setLoading(true);
        const params = {
            page,
            limit: perPage,
            bd,
        };
        if (searchAgencyId) params.search = searchAgencyId;
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASEURL1}/admin/withdrawal/getAllBillsToBdByAgency`, { params });
            if (res.data.success) {
                setBills(res.data.details);
                setTotalEntries(res.data.totalEntries);
            } else {
                setBills([]);
                setTotalEntries(0);
            }
        } catch (error) {
            setBills([]);
            setTotalEntries(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBills();
        // eslint-disable-next-line
    }, [bd, page, perPage]);

    const handleSearch = () => {
        setPage(1);
        fetchBills(searchInput.trim());
    };

    // Animation for modal
    const modalAnim = {
        animation: "fadeInScale 0.3s cubic-bezier(.4,2,.6,1) both"
    };

    return (
        <div style={{
            maxWidth: 1100,
            margin: "40px auto",
            padding: "32px 20px",
            background: "#f6f9fc",
            borderRadius: 18,
            boxShadow: "0 8px 32px #0001",
            minHeight: 600,
            fontFamily: "Inter, Segoe UI, Arial, sans-serif",
            position: "relative"
        }}>
            <h2 style={{
                textAlign: "center",
                fontWeight: 700,
                fontSize: 32,
                letterSpacing: 1,
                marginBottom: 18,
                color: "#222"
            }}>
                Agency Bills To BD
            </h2>
            <div style={{ display: "flex", gap: 16, marginBottom: 20, alignItems: "center", flexWrap: "wrap" }}>
                <input
                    type="text"
                    placeholder="Search Agency Unique ID"
                    value={searchInput}
                    onChange={e => setSearchInput(e.target.value)}
                    style={{
                        padding: "7px 12px",
                        border: "1px solid #d9d9d9",
                        borderRadius: 6,
                        fontSize: 15,
                        background: "#fff"
                    }}
                />
                <button
                    style={{
                        padding: "7px 28px",
                        fontSize: 16,
                        background: "#1677ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 5,
                        fontWeight: 500,
                        cursor: "pointer"
                    }}
                    onClick={handleSearch}
                >
                    Go
                </button>
            </div>
            <div style={{
                overflowX: "auto",
                borderRadius: 10,
                boxShadow: "0 2px 12px #0001",
                background: "#fff"
            }}>
                <table style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    fontSize: 16,
                    minWidth: 900
                }}>
                    <thead>
                        <tr style={{
                            background: "#f0f5ff",
                            color: "#222",
                            fontWeight: 600
                        }}>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>S.No</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Agency Unique ID</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Start Date</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>End Date</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Created At</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Status</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Paid Bill</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={8} style={{ textAlign: "center", padding: 32, fontSize: 18, color: "#888" }}>
                                    Loading...
                                </td>
                            </tr>
                        ) : bills.length === 0 ? (
                            <tr>
                                <td colSpan={8} style={{ textAlign: "center", padding: 32, fontSize: 18, color: "#888" }}>
                                    No records found
                                </td>
                            </tr>
                        ) : (
                            bills.map((bill, idx) => (
                                <tr
                                    key={bill._id}
                                    style={{
                                        background: idx % 2 === 0 ? "#fafcff" : "#f6f9fc",
                                        transition: "background 0.2s"
                                    }}
                                >
                                    <td style={{ padding: 10, textAlign: "center" }}>{(page - 1) * perPage + idx + 1}</td>
                                    <td style={{ padding: 10, textAlign: "center" }}>{bill.uniqueId}</td>
                                    <td style={{ padding: 10, textAlign: "center" }}>{bill.startDate ? new Date(bill.startDate).toLocaleDateString() : "-"}</td>
                                    <td style={{ padding: 10, textAlign: "center" }}>{bill.endDate ? new Date(bill.endDate).toLocaleDateString() : "-"}</td>
                                    <td style={{ padding: 10, textAlign: "center" }}>{bill.createdAt ? new Date(bill.createdAt).toLocaleString() : "-"}</td>
                                    <td style={{
                                        padding: 10,
                                        textAlign: "center",
                                        color: statusColors[bill.approved],
                                        fontWeight: 600,
                                        letterSpacing: 1
                                    }}>
                                        {bill.approved === 0 ? "Pending" : bill.approved === 1 ? "Approved" : "Rejected"}
                                    </td>
                                    <td style={{ padding: 10, textAlign: "center" }}>
                                        {bill.approved === 1 && bill.billPath ? (
                                            <a
                                                href={`${process.env.REACT_APP_BASEURL1}/${bill.billPath}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="download-link"
                                            >
                                                Download
                                            </a>
                                        ) : (
                                            <span style={{ color: "#aaa" }}>-</span>
                                        )}
                                    </td>
                                    <td style={{ padding: 10, textAlign: "center" }}>
                                        {bill.billPath ? (
                                            <a
                                                href={`${process.env.REACT_APP_BASEURL1}/${bill.billPath}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="bill-btn"
                                                style={{
                                                    background: "#13c2c2",
                                                    boxShadow: "0 2px 8px #13c2c244",
                                                    color: "#fff",
                                                    padding: "6px 18px",
                                                    borderRadius: 6,
                                                    fontWeight: 600,
                                                    textDecoration: "none"
                                                }}
                                            >
                                                View
                                            </a>
                                        ) : (
                                            <span style={{ color: "#aaa" }}>-</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: 24,
                flexWrap: "wrap",
                gap: 10
            }}>
                <div>
                    <button
                        style={{
                            background: page === 1 ? "#d9d9d9" : "#1677ff",
                            color: page === 1 ? "#888" : "#fff",
                            cursor: page === 1 ? "not-allowed" : "pointer",
                            marginRight: 8,
                            border: "none",
                            borderRadius: 5,
                            padding: "7px 18px"
                        }}
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>
                    <button
                        style={{
                            background: page * perPage >= totalEntries ? "#d9d9d9" : "#1677ff",
                            color: page * perPage >= totalEntries ? "#888" : "#fff",
                            cursor: page * perPage >= totalEntries ? "not-allowed" : "pointer",
                            border: "none",
                            borderRadius: 5,
                            padding: "7px 18px"
                        }}
                        disabled={page * perPage >= totalEntries}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>
                </div>
                <span style={{ fontSize: 16 }}>
                    Page <b>{page}</b> of <b>{Math.ceil(totalEntries / perPage) || 1}</b>
                </span>
                <span style={{ fontSize: 16 }}>
                    Entries per page:&nbsp;
                    <select
                        value={perPage}
                        onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }}
                        style={{
                            padding: "5px 12px",
                            border: "1px solid #d9d9d9",
                            borderRadius: 5,
                            fontSize: 15,
                            background: "#fff"
                        }}
                    >
                        {[10, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                </span>
                <span style={{ fontSize: 16 }}>
                    Total Entries: <b>{totalEntries}</b>
                </span>
            </div>
            {/* Modal for InvoiceForBd removed, now View opens PDF in new tab */}
        </div>
    );
};

export default AgencyBillListToBd;